import React, { memo, useMemo } from 'react';
import { Box } from '@mui/material';
import PlusIcon from '@/shared/assets/icons/treatment-creation-result/info-panel/EMDR-Plus.svg?react';
import RemoteIcon from '@/shared/assets/icons/treatment-creation-result/info-panel/EMDR-Remote.svg?react';
import VRIcon from '@/shared/assets/icons/treatment-creation-result/info-panel/EMDR-VR.svg?react';

import { pillIconStyles } from './style';

export const CustomMuiDatatableEmdrType = memo(({ type }) => {
  const { container } = pillIconStyles;

  const TreatmentIcon = useMemo(() => {
    switch (type) {
      case 'EMDR-Remote':
        return <RemoteIcon className='remote' />;
      case 'EMDR-Plus':
        return <PlusIcon className='plus' />;
      case 'EMDR-VR':
        return <VRIcon className='vr' />;
    }
  }, [type]);

  return (
    <Box sx={container}>
      {TreatmentIcon} {type}
    </Box>
  );
});
